<template>
    <div id="our-packages-page">
        <AppHero :heading="'Our Packages'">
            <p class="body-copy body-copy--align-center">
                Whatever your branding needs are we have a package that’s the right size for you. If you
                need a bit more, get in touch for our bespoke package offers.
            </p>
        </AppHero>

        <PackagesSection />

        <GetStarted />
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import PackagesSection from "@/views/OurPackages/PackagesSection";
    import GetStarted from "@/components/layout/GetStarted";

    export default {
        name: 'OurPackages',
        components: {
            AppHero,
            PackagesSection,
            GetStarted
        }
    }
</script>